import { HubFeature } from "@ats/api/cm";
import { LocDefs, LocMap, MapLocKeys } from "@cm/core/localization";

export type CPCreqEditLocs =
	| 'CPCreqEditFieldErrorPointsRequired'
	| 'CPCreqEditFieldErrorPointsNumeric'
	| 'CPCreqEditFieldErrorPointsFactor'
	| 'CPCreqEditPointsMax'
	| 'CPCreqEditPointsMin'
    | 'CPCreqEditFieldLabelFactorNotFound';

export const cpCreqEditLocs: LocDefs<CPCreqEditLocs> = {
    CPCreqEditFieldErrorPointsRequired: {
        defaultValue: ' are required',
        description: 'Error message when points are required',
        displayPath: 'History|Edit|Points Required',
        displayType: 'Error',
        feature: HubFeature.CredentialContinuingEducationCandidateCeuEdit,
        portal: 'CP',
    },
    CPCreqEditFieldErrorPointsNumeric: {
        defaultValue: 'must be a positive whole number.',
        description: 'Error message when points are not numeric',
        displayPath: 'History|Edit|Points Numeric',
        displayType: 'Error',
        feature: HubFeature.CredentialContinuingEducationCandidateCeuEdit,
        portal: 'CP',
    },
    CPCreqEditFieldErrorPointsFactor: {
        defaultValue: 'Points must be a multiple of',
        description: 'Error message when points are not a multiple of the factor',
        displayPath: 'History|Edit|Points Factor',
        displayType: 'Error',
        feature: HubFeature.CredentialContinuingEducationCandidateCeuEdit,
        portal: 'CP',
    },
    CPCreqEditPointsMax: {
        defaultValue: 'Points must be less than or equal to:',
        description: 'Hint/error message displayed when max points is set.',
        displayPath: `History|Edit|Max Points`,
        displayType: 'Error',
        feature: HubFeature.CredentialContinuingEducationCandidateCeuEdit,
        portal: 'CP',
    },
    CPCreqEditPointsMin: {
        defaultValue: 'Points must be greater than or equal to:',
        displayPath: `History|Edit|Minimum Points`,
        description: `Hint/error message displayed when catalog points is set.`,
        displayType: 'Error',
        feature: HubFeature.CredentialContinuingEducationCandidateCeuEdit,
        portal: 'CP',
    },
    CPCreqEditFieldLabelFactorNotFound: {
        defaultValue: 'Points',
        description: 'Label for the points field when factor is not found',
        displayPath: 'History|Edit|Label|Factor Not Found',
        displayType: 'Label',
        feature: HubFeature.CredentialContinuingEducationCandidateCeuEdit,
        portal: 'CP',
      },
};
    
export type CPCreqEditLocKeys = LocMap<CPCreqEditLocs>;
export const cpCreqEditLocKeys: CPCreqEditLocKeys =
    MapLocKeys<CPCreqEditLocs>(cpCreqEditLocs);